export const template = `
<ng-content select="sdc-tile-header"></ng-content>
<ng-content select="sdc-tile-content"></ng-content>
<ng-content select="sdc-tile-footer"></ng-content>
`;
